import { AuthUser } from './auth-user.model';

/**
 * Shape returned by the API `GET /me` endpoint. The store/permission profile
 * that used to be embedded in the Cognito access token now comes from the
 * backend user_access table, keyed by the signed-in user's email.
 */
export interface MeDto {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  defaultStore?: string;
  allowedStores?: string[];
  permissions?: string[];
  sentToProductionEmails?: string[];
  availablePriceLists?: string[];
  defaultPriceList?: string;
}

export const REQUIRED_USER_PROPS: Array<keyof AuthUser> = ['email', 'username'];

export function createAuthUserFromMe(dto?: MeDto): AuthUser | undefined {
  if (!dto) {
    return undefined;
  }

  return {
    username: dto.username,
    email: dto.email,
    firstName: dto.firstName ?? '',
    lastName: dto.lastName ?? '',
    defaultStore: dto.defaultStore || undefined,
    allowedStores: dto.allowedStores ?? [],
    sentToProductionEmails: dto.sentToProductionEmails ?? [],
    permissions: dto.permissions ?? [],
  } satisfies AuthUser;
}
